import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { setView, toggleFilter } from '@r1-frontend/entities/ConnectDomruPopup/context/actions';
import { sendRequest } from '@r1-frontend/entities/ConnectDomruPopup/context/actions/thunk/sendRequest';
import { useContextDispatch, useContextSelector } from '@r1-frontend/entities/ConnectDomruPopup/context/hooks';
import { getSelectedProductsIds, selectFilters } from '@r1-frontend/entities/ConnectDomruPopup/context/selectors';
import { selectCsrf } from '@r1-frontend/entities/stores/auth/selectors/selectCsrf';

import PopupCallBackNoAuth, { ISubmitParam } from '@r1-frontend/ui-react/components/popups/popupCallback';
import { CATEGORIES } from '@r1-frontend/shared/constants/analytics';

import * as ST from './styled';

const RequestCallback = () => {
    const csrf = useSelector(selectCsrf);

    const { filters, selectedProductsIds } = useContextSelector(state => ({
        filters: selectFilters(state),
        selectedProductsIds: getSelectedProductsIds(state),
    }));

    const dispatch = useContextDispatch();

    const handleToggleFilter = (value: string) => () => {
        dispatch(toggleFilter(value));
    };

    const sendBecomeClient = useCallback((clientData: ISubmitParam) => {
        dispatch(sendRequest(clientData, csrf));
    }, []);

    const handleClose = () => {
        dispatch(setView('none'));
    };

    return (
        <PopupCallBackNoAuth
            isOpen
            onClose={handleClose}
            title={'Заявка на подключение'}
            buttonText={'Подключить'}
            submitRequest={sendBecomeClient}
            waitStatus={false}
            option={`popup | ${selectedProductsIds.join(',')}`}
            category={CATEGORIES.applicationFormHeader}
        >
            <ST.SMultiCheckboxWrapper>
                {filters.map((item, index) => (
                    <ST.SMultiCheckbox
                        key={`Selectable_service:${index}-id:${item.id}`}
                        value={item.value}
                        onChange={handleToggleFilter(item.value)}
                        checked={item.checked}
                    >
                        {item.value}
                    </ST.SMultiCheckbox>
                ))}
            </ST.SMultiCheckboxWrapper>
        </PopupCallBackNoAuth>
    );
};

export default RequestCallback;
